export default "<div class=\"content-container\">\n  <div [innerHTML]=\"projectMDhtml\" class=\"project-content\">\n\n  </div>\n</div>\n"